import { fork } from "redux-saga/effects";
import generalSaga from "./generalSaga.ts";
import importFileDataSaga from "./importFileDataSaga.ts";

function* rootSaga() {
  yield fork(generalSaga);
  yield fork(importFileDataSaga);
}

export default rootSaga;
